module.exports = __webpack_public_path__ + "img/title.b14a8967.png";